import { options as n, Fragment as t } from "preact";
var r,
    u,
    i,
    o,
    f = 0,
    c = [],
    e = [],
    a = n.__b,
    v = n.__r,
    l = n.diffed,
    m = n.__c,
    d = n.unmount;

function p(t, r) {
  n.__h && n.__h(u, t, f || r), f = 0;
  var i = u.__H || (u.__H = {
    __: [],
    __h: []
  });
  return t >= i.__.length && i.__.push({
    __V: e
  }), i.__[t];
}

function y(n) {
  return f = 1, h(C, n);
}

function h(n, t, i) {
  var o = p(r++, 2);

  if (o.t = n, !o.__c && (o.__ = [i ? i(t) : C(void 0, t), function (n) {
    var t = o.__N ? o.__N[0] : o.__[0],
        r = o.t(t, n);
    t !== r && (o.__N = [r, o.__[1]], o.__c.setState({}));
  }], o.__c = u, !u.u)) {
    u.u = !0;
    var f = u.shouldComponentUpdate;

    u.shouldComponentUpdate = function (n, t, r) {
      if (!o.__c.__H) return !0;

      var u = o.__c.__H.__.filter(function (n) {
        return n.__c;
      });

      if (u.every(function (n) {
        return !n.__N;
      })) return !f || f.call(this, n, t, r);
      var i = !1;
      return u.forEach(function (n) {
        if (n.__N) {
          var t = n.__[0];
          n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
        }
      }), !!i && (!f || f.call(this, n, t, r));
    };
  }

  return o.__N || o.__;
}

function s(t, i) {
  var o = p(r++, 3);
  !n.__s && B(o.__H, i) && (o.__ = t, o.i = i, u.__H.__h.push(o));
}

function _(t, i) {
  var o = p(r++, 4);
  !n.__s && B(o.__H, i) && (o.__ = t, o.i = i, u.__h.push(o));
}

function A(n) {
  return f = 5, T(function () {
    return {
      current: n
    };
  }, []);
}

function F(n, t, r) {
  f = 6, _(function () {
    return "function" == typeof n ? (n(t()), function () {
      return n(null);
    }) : n ? (n.current = t(), function () {
      return n.current = null;
    }) : void 0;
  }, null == r ? r : r.concat(n));
}

function T(n, t) {
  var u = p(r++, 7);
  return B(u.__H, t) ? (u.__V = n(), u.i = t, u.__h = n, u.__V) : u.__;
}

function q(n, t) {
  return f = 8, T(function () {
    return n;
  }, t);
}

function x(n) {
  var t = u.context[n.__c],
      i = p(r++, 9);
  return i.c = n, t ? (null == i.__ && (i.__ = !0, t.sub(u)), t.props.value) : n.__;
}

function P(t, r) {
  n.useDebugValue && n.useDebugValue(r ? r(t) : t);
}

function V(n) {
  var t = p(r++, 10),
      i = y();
  return t.__ = n, u.componentDidCatch || (u.componentDidCatch = function (n, r) {
    t.__ && t.__(n, r), i[1](n);
  }), [i[0], function () {
    i[1](void 0);
  }];
}

function b() {
  var n = p(r++, 11);
  return n.__ || (n.__ = "P" + function (n) {
    for (var t = 0, r = n.length; r > 0;) {
      t = (t << 5) - t + n.charCodeAt(--r) | 0;
    }

    return t;
  }(u.__v.o) + r), n.__;
}

function g() {
  for (var t; t = c.shift();) {
    if (t.__P && t.__H) try {
      t.__H.__h.forEach(w), t.__H.__h.forEach(z), t.__H.__h = [];
    } catch (r) {
      t.__H.__h = [], n.__e(r, t.__v);
    }
  }
}

n.__b = function (n) {
  "function" != typeof n.type || n.o || n.type === t ? n.o || (n.o = n.__ && n.__.o ? n.__.o : "") : n.o = (n.__ && n.__.o ? n.__.o : "") + (n.__ && n.__.__k ? n.__.__k.indexOf(n) : 0), u = null, a && a(n);
}, n.__r = function (n) {
  v && v(n), r = 0;
  var t = (u = n.__c).__H;
  t && (i === u ? (t.__h = [], u.__h = [], t.__.forEach(function (n) {
    n.__N && (n.__ = n.__N), n.__V = e, n.__N = n.i = void 0;
  })) : (t.__h.forEach(w), t.__h.forEach(z), t.__h = [])), i = u;
}, n.diffed = function (t) {
  l && l(t);
  var r = t.__c;
  r && r.__H && (r.__H.__h.length && (1 !== c.push(r) && o === n.requestAnimationFrame || ((o = n.requestAnimationFrame) || k)(g)), r.__H.__.forEach(function (n) {
    n.i && (n.__H = n.i), n.__V !== e && (n.__ = n.__V), n.i = void 0, n.__V = e;
  })), i = u = null;
}, n.__c = function (t, r) {
  r.some(function (t) {
    try {
      t.__h.forEach(w), t.__h = t.__h.filter(function (n) {
        return !n.__ || z(n);
      });
    } catch (u) {
      r.some(function (n) {
        n.__h && (n.__h = []);
      }), r = [], n.__e(u, t.__v);
    }
  }), m && m(t, r);
}, n.unmount = function (t) {
  d && d(t);
  var r,
      u = t.__c;
  u && u.__H && (u.__H.__.forEach(function (n) {
    try {
      w(n);
    } catch (n) {
      r = n;
    }
  }), u.__H = void 0, r && n.__e(r, u.__v));
};
var j = "function" == typeof requestAnimationFrame;

function k(n) {
  var t,
      r = function r() {
    clearTimeout(u), j && cancelAnimationFrame(t), setTimeout(n);
  },
      u = setTimeout(r, 100);

  j && (t = requestAnimationFrame(r));
}

function w(n) {
  var t = u,
      r = n.__c;
  "function" == typeof r && (n.__c = void 0, r()), u = t;
}

function z(n) {
  var t = u;
  n.__c = n.__(), u = t;
}

function B(n, t) {
  return !n || n.length !== t.length || t.some(function (t, r) {
    return t !== n[r];
  });
}

function C(n, t) {
  return "function" == typeof t ? t(n) : t;
}

export { q as useCallback, x as useContext, P as useDebugValue, s as useEffect, V as useErrorBoundary, b as useId, F as useImperativeHandle, _ as useLayoutEffect, T as useMemo, h as useReducer, A as useRef, y as useState };